/*
 * @Description: 入口文件
 * @Author: 山淑兰
 * @Date: 2019-12-16 13:35:21
 * @LastEditTime : 2020-01-14 15:29:49
 * @LastEditors  : 山淑兰
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import middleware from "./middleware/index";
import Api from "./api/index";
import ElementUI from "element-ui";
import "./mock/index";
import filters from "./filters/index";

import "element-ui/lib/theme-chalk/index.css";
import "./scss/main.scss";
import "./scss/common.scss";
import './lib/dist/css/swiper.min.css'
import './lib/dist/js/swiper.min.js'

Vue.config.productionTip = false;
Vue.use(ElementUI);

Vue.prototype.$http = Api;

// middleware(router);
Object.keys(filters).forEach(k => Vue.filter(k, (filters as any)[k]));

(window as any).VUE = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
